import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Button, Col, Form, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import {FormattedMessage} from "react-intl";
import LaddaButton, {ZOOM_OUT} from 'react-ladda';
import SelectAnswers from "../../../../../../../Structure/components/SelectAnswers";
import api from "../../../../../../../../../api";
import SelectExcludings from "../../../../../../../Structure/components/SelectExcludings";

class ColumnTfoot extends Component {
  constructor(props) {
    super(props);

    this.state = {
      saving: false,
      answer: false,
      excluding: false,
      content: false,
      modalIsOpen: false,
    };

    this.modalToggle = this.modalToggle.bind(this);
    this.save = this.save.bind(this);
  }

  modalToggle(answer = false, content = false, excluding = false){
    this.setState({
      modalIsOpen: !this.state.modalIsOpen,
      answer,
      excluding,
      content,
    });
  }

  save(){
    const {answer, excluding, content} = this.state;
    const {question, responsesSelected} = this.props;

    this.setState({
      saving: true,
    });

    let data = {
      responses: responsesSelected,
      answer,
      excluding,
      content,
    };

    api.questionResponse.question.patchDetails(question.id, data)
    .then(data => {
      this.setState({
        saving: false,
        answer: false,
        excluding: false,
        content: false,
        modalIsOpen: false,
      });

      this.props.onSaved();
    })
    .catch(res => {
      this.setState({
        saving: false,
      });
    });
  }

  render() {
    const {modalIsOpen, saving, excluding, answer, content} = this.state;
    const {responsesSelected, question} = this.props;

    return <React.Fragment>
      <td className="border-left border-right">
        <Button disabled={responsesSelected.length === 0} size="sm" color="secondary" className="w-100 text-center" onClick={() => this.modalToggle(null)}>Zmień</Button>
      </td>

      {question.answers.find(answer => answer.isOpen) && <td className="border-left border-right">
        <Button disabled={responsesSelected.length === 0} size="sm" color="secondary" className="w-100 text-center" onClick={() => this.modalToggle(false, '')}>Zmień</Button>
      </td>}

      {question.excludings.length > 0 && <td>
        <Button
          onClick={() => this.modalToggle(false, false, null)}
          disabled={responsesSelected.length === 0}
          size="sm"
          color="secondary"
          className="w-100 text-center"
        >Zmień</Button>
      </td>}



      {modalIsOpen && <Modal isOpen={modalIsOpen} toggle={() => this.modalToggle(false)} size="xl">
        <ModalHeader tag="h2" toggle={() => this.modalToggle(false)}>Zmień odpowiedź dla wybranych wywiadów</ModalHeader>
        <hr className="my-0"/>
        <ModalBody>
          <Form>
            <FormGroup row>
              <Label md={3}>Liczba zaznaczonych wywiadów:</Label>
              <Col md={9} className="d-flex align-items-center">{responsesSelected.length}</Col>
            </FormGroup>
            {answer !== false && <FormGroup row>
              <Label md={3}>W zaznaczonych wywiadach zmień odpowiedź na:</Label>
              <Col md={9} className="d-flex align-items-center">
                <SelectAnswers
                  value={answer || null}
                  placeholder="Usuń odpowiedź lub wybierz aby zmienić"
                  isClearable={true}
                  className="w-100"
                  isMulti={false}
                  questionId={question.id}
                  onChange={(answer) => this.setState({answer, excluding: false, content: false})}
                />
              </Col>
            </FormGroup>}
            {content !== false && <FormGroup row>
              <Label md={3}>W zaznaczonych wywiadach zmień odpowiedź wpisywaną na:</Label>
              <Col md={9} className="d-flex align-items-center">
                <Input type="text" onChange={e => this.setState({answer: false, excluding: false, content: e.target.value})} />
              </Col>
            </FormGroup>}
            {(excluding !== false && question.excludings.length > 0) && <FormGroup row>
              <Label md={3}>W zaznaczonych wywiadach zmień odpowiedź na:</Label>
              <Col md={9} className="d-flex align-items-center">
                <SelectExcludings
                  placeholder="Wybierz odpowiedź wykluczającą"
                  value={excluding || null}
                  isClearable={true}
                  className="w-100"
                  isMulti={false}
                  questionId={question.id}
                  onChange={(excluding) => this.setState({excluding, answer: false, content: false,})}
                />
              </Col>
            </FormGroup>}
          </Form>
        </ModalBody>
        <ModalFooter>
          <FormattedMessage id="_.button.cancel">{
            (message) =>
              <Button color="secondary" className="mb-0" onClick={() => this.modalToggle(false)}>{message}</Button>
          }</FormattedMessage>
          <FormattedMessage id="_.button.save">{
            (message) => <LaddaButton
              className="btn btn-primary btn-ladda mb-0"
              loading={saving}
              data-style={ZOOM_OUT}
              onClick={() => this.save()}
            >
              {message}
            </LaddaButton>
          }</FormattedMessage>
        </ModalFooter>
      </Modal>}

    </React.Fragment>;
  }
}

ColumnTfoot.propTypes = {
  question: PropTypes.shape({
    id: PropTypes.number.isRequired,
    type: PropTypes.oneOf(['single']),
    answers: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      position: PropTypes.number.isRequired,
      content: PropTypes.string.isRequired,
    }),),
    excludings: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      content: PropTypes.string.isRequired,
    }),),
  }).isRequired,
  responsesSelected: PropTypes.arrayOf(PropTypes.number,),
  onSaved: PropTypes.func.isRequired,
};

export default ColumnTfoot;